module.exports = __webpack_public_path__ + "static/media/wpreview.dabae29c.png";